import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import DateInputProps from './DateInputProps'

import Messages from './Messages'

export default {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: DateInputProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent,
        Messages
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoDateInput(that.widgetOptions)
        var widget = that.kendoWidget()

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }

        that.kendoWidget().bind('change', function () {
            if(that.v3){
                that.$emit('update:modelValue', widget.value())
            } else {
                that.$emit('changemodel', widget.value())
            }
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDateInput()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateInput/KendoDateInputMixin.js